import { c as _c } from "react/compiler-runtime";
import { Maybe } from '@/utils/types';
import { useTranslation } from 'react-i18next';
interface Props {
  value: Maybe<string>;
}
export function LegalRelationship(t0) {
  const $ = _c(10);
  const {
    value
  } = t0;
  const {
    t
  } = useTranslation("career");
  switch (value) {
    case "workContractOrTradeLicense":
      {
        let t1;
        if ($[0] !== t) {
          t1 = t("legalRelationship.workContractOrTradeLicense");
          $[0] = t;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        return t1;
      }
    case "workContract":
      {
        let t1;
        if ($[2] !== t) {
          t1 = t("legalRelationship.workContract");
          $[2] = t;
          $[3] = t1;
        } else {
          t1 = $[3];
        }
        return t1;
      }
    case "tradeLicense":
      {
        let t1;
        if ($[4] !== t) {
          t1 = t("legalRelationship.tradeLicense");
          $[4] = t;
          $[5] = t1;
        } else {
          t1 = $[5];
        }
        return t1;
      }
    case "agreementOnWorkActivityDPP":
      {
        let t1;
        if ($[6] !== t) {
          t1 = t("legalRelationship.agreementOnWorkActivityDPP");
          $[6] = t;
          $[7] = t1;
        } else {
          t1 = $[7];
        }
        return t1;
      }
    case "agreementOnWorkActivityDPC":
      {
        let t1;
        if ($[8] !== t) {
          t1 = t("legalRelationship.agreementOnWorkActivityDPC");
          $[8] = t;
          $[9] = t1;
        } else {
          t1 = $[9];
        }
        return t1;
      }
    default:
      {
        return null;
      }
  }
}